define('views/modules/calendar/nutrition/food/details/details-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/form/textbox',
    // templates
    'text!templates/modules/calendar/nutrition/food/details/details-form.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VTextbox,
    // templates
    TFoodDetailsForm
) {

    var VFoodDetailsForm = Backbone.View.extend({
        template: TFoodDetailsForm,

        // abstracting selectors out of the view logic
        regions: {
            name: ".food-name",
            serving: ".food-serving",
        },

        initialize: function(options) {
            var serving = this.serving = options.serving,
                model = this.model;

            this.view = {
                name: new VTextbox({ label: 'Name', attribute: 'name', labelposition: 'outer', model: this.model }),
                serving: new VTextbox({ attribute: 'name', label: 'calendar:Serving name', labelposition: 'top', placeholder: 'calendar:Serving name placeholder', model: serving }),
            };
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            // Assign Views
            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.name, zone.$name)
                .assign(view.serving, zone.$serving);

            return this;
        },

    });

    return VFoodDetailsForm;

});

